import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NumberingLogic } from '@work4all/models/lib/Classes/NumberingLogic.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

interface ExtendedNumberingLogic extends NumberingLogic {
  id?: number;
  name?: string;
}

const NUMBERING_LOGIC_DATA: ExtendedNumberingLogic = {
  objType: null,
  firstNumber: null,
  lastNumber: null,
};

const newEntryMandatoryFields: (keyof NumberingLogic)[] = [
  'firstNumber',
  'lastNumber',
];

export const NumberingLogicTable = () => {
  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<ExtendedNumberingLogic>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 160,
        editable: false,
      },
      {
        Header: t('NUMBERINGLOGIC.FIRST_NUMBER'),
        accessor: 'firstNumber',
        type: 'number',
        width: 120,
        numberCellProps: {
          showThousandsSeparator: false,
        },
      },
      {
        Header: t('NUMBERINGLOGIC.LAST_NUMBER'),
        accessor: 'lastNumber',
        width: 120,
        type: 'number',
        numberCellProps: {
          showThousandsSeparator: false,
        },
      },
    ],
    [t]
  );

  return (
    <EditableEntityTable<ExtendedNumberingLogic>
      columns={cols}
      dataFields={NUMBERING_LOGIC_DATA}
      entity={Entities.numberingLogic}
      idType="number"
      sortByField="name"
      newEntryMandatoryFields={newEntryMandatoryFields}
      transformAfterLoading={(item) => ({
        ...item,
        id: item.objType,
        name: t(`NUMBERINGLOGIC.${item.objType}`),
      })}
      transformBeforeUpdate={(item) => ({ ...item, objType: item.id })}
      dataProviderProps={{
        completeDataResponse: true,
      }}
      enableNewItems={false}
    />
  );
};
